import { render, staticRenderFns } from "./AttackDetection.vue?vue&type=template&id=2de22fd7&scoped=true"
import script from "./AttackDetection.vue?vue&type=script&lang=js"
export * from "./AttackDetection.vue?vue&type=script&lang=js"
import style0 from "./AttackDetection.vue?vue&type=style&index=0&id=2de22fd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de22fd7",
  null
  
)

export default component.exports